module.exports = __webpack_public_path__ + "resources/img/img_vehicle_m.4421c6f9516d24eef15b71a0d35d9298.png";